<template>
  <v-form
  class="mx-12 px-12 mb-10 pa-10 text-center"
    ref="form"
    lazy-validation>

    <h3 class="text-left mb-5 text-primary">Status</h3>
    <v-layout>
      <v-flex md4>
        <v-btn
            color="primary"
            @click="isRunning"
            style="color:white"
            :loading="loadingRun"
            :disabled="loadingEnabled || loadingEnable">
          is Running?
        </v-btn>
      </v-flex>
      <v-flex md4>
        <v-btn
            color="primary"
            @click="isEnabled"
            style="color:white"
            :loading="loadingEnabled"
            :disabled="loadingRun || loadingEnable"
        >
          is Enabled?
        </v-btn>
      </v-flex>
      <v-flex md4>
        <v-btn
            color="primary"
            @click="enable"
            style="color:white"
            :loading="loadingEnable"
            :disabled="loadingRun || loadingEnabled"
        >
          Enable
        </v-btn>
      </v-flex>
    </v-layout>

  </v-form>
</template>
<script>
  import alisonJS from  '@/services/alison_js.js'
  import { mapMutations } from 'vuex'
  export default {
    data: () => ({
      loadingRun: false,
      loadingEnabled: false,
      loadingEnable: false,
    }),
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),

      isEnabled(){
        this.loadingEnabled = true;
        alisonJS.isEnabled().then(responseEnabled=>{
          this.loadingEnabled = false
          if(responseEnabled){
            this.setColor('info')
            this.setSnack('Alison desktop is enabled!')
          } else {
            this.setColor('error')
            this.setSnack('Alison desktop is not enabled!')
          }
        })
      },
      isRunning(){
        this.loadingRun = true;
        alisonJS.isRunning().then(running=>{
          this.loadingRun = false
          console.log("alisonJS:", alisonJS)
          if(running){
            this.setColor('info')
            this.setSnack('Alison desktop is running! version: '+alisonJS.desktopVersion())
          } else {
            this.setColor('error')
            this.setSnack('Alison desktop is not running!')
          }
        })
      },
      enable(){
        this.loadingEneble = true;
        alisonJS.enable().then(enable=>{
            console.log("enable:", enable)
            this.loadingEnable = false
            this.setColor('info')
            this.setSnack('AlisonDesktop.enable() called!')
        })
      },
    }
  }
</script>